

<div *ngFor="let category of items"> 
    <button mat-menu-item (click)="goToCategory(category)">
        <span>{{category.categoryName}}</span>
    </button>
    <div *ngIf="category.subcategories.length>0"  class="sub-category">

        <calsoft-sub-category-child-items [items]="category.subcategories"></calsoft-sub-category-child-items>
     </div>
</div>